"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var appender_base_1 = require("./appender.base");
var enums_1 = require("../enums");
/**
 * Writes **message text** to the console - same as using `console.*` JS calls.
 * Can handle errors as well.
 */
var ConsoleNativeAppender = /** @class */ (function (_super) {
    __extends(ConsoleNativeAppender, _super);
    function ConsoleNativeAppender() {
        var _this = _super.call(this) || this;
        _this.type = enums_1.AppenderType.ConsoleNative;
        return _this;
    }
    ConsoleNativeAppender.prototype.getAppenderName = function () { return 'ConsoleNativeAppender'; };
    ConsoleNativeAppender.prototype.action = function (message) {
        this.useNativeConsole(message.level, message.value, message.exception);
    };
    ConsoleNativeAppender.prototype.useNativeConsole = function (level, message, error) {
        switch (level) {
            case enums_1.LogLevel[enums_1.LogLevel.Error]:
            case enums_1.LogLevel[enums_1.LogLevel.Fatal]:
                console.error(message, error);
                break;
            case enums_1.LogLevel[enums_1.LogLevel.Warn]:
                console.warn(message);
                break;
            default:
                console.log(message);
                break;
        }
    };
    return ConsoleNativeAppender;
}(appender_base_1.Appender));
exports.ConsoleNativeAppender = ConsoleNativeAppender;
//# sourceMappingURL=appender.console-native.js.map